import storageKeys from 'data/storageKeys';
import { getDataFromSessionStorage, formatDataType } from 'components/Booking-new/utils/helpers';

class SessionStorageProvider {
  updateState(state, storageData) {
    return {
      ...state,
      ...storageData?.activeStep,
      userData: {
        ...state.userData,
        ...storageData?.userData,
      },
      config: {
        ...state.config,
        ...storageData?.config,
      },
    };
  }

  getUpdatedState(functions, currentState) {
    return Object.keys(functions).reduce(
      (state, key) => {
        const getFormattedData = functions[key];
        const data = getDataFromSessionStorage(key);

        return this.updateState(state, getFormattedData(data));
      },
      { ...currentState },
    );
  }

  getState(currentState) {
    const bookingId = currentState.bookingPrefix;
    const sessionStorageKeyFunctions = {
      [bookingId]: data => data,
      [storageKeys.userData]: data => formatDataType(data),
    };

    return this.getUpdatedState(sessionStorageKeyFunctions, currentState);
  }
}

export default SessionStorageProvider;
